
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(562|906)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
